import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { SocketProvider } from './contexts/SocketContext';
import { Toaster } from 'react-hot-toast';
import ErrorBoundary from './components/ErrorBoundary';
import NetworkStatus from './components/NetworkStatus';
import InstallPrompt from './components/InstallPrompt';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Menus from './pages/Menus';
import MenuItems from './pages/MenuItems';
import MenuAddons from './pages/MenuAddons';
import AddonGroups from './pages/AddonGroups';
import Orders from './pages/Orders';
import OrderReports from './pages/OrderReports';
import Payouts from './pages/Payouts';
import KotSettings from './pages/KotSettings';
import Profile from './pages/Profile';
import Layout from './components/Layout';
import Orderschedule from './pages/Orderschedule';
import OrderscheduleCreate from './pages/Createorderschedule';
import Editorderschedule from './pages/Editorderschedule';
import OrderscheduleEdit from './pages/Editorderschedule';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    );
  }
  
  return isAuthenticated ? children : <Navigate to="/login" />;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <PrivateRoute>  
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="menus" element={<Menus />} />
        <Route path="menu-items" element={<MenuItems />} />
        <Route path="addons" element={<MenuAddons />} />
        <Route path="addon-groups" element={<AddonGroups />} />
        <Route path="orders" element={<Orders />} />
        <Route path="order-schedule" element={<Orderschedule />} />
        <Route path="order-schedule/create" element={<OrderscheduleCreate />} />
        <Route path="order-schedule/:id/edit" element={<OrderscheduleEdit />} />
        <Route path="order-schedule/:id" element={<OrderscheduleEdit />} />
        <Route path="reports" element={<OrderReports />} />
        <Route path="payouts" element={<Payouts />} />
        <Route path="kot-settings" element={<KotSettings />} />
        <Route path="profile" element={<Profile />} />
      </Route>
    </Routes>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <SocketProvider>
          <AppRoutes />
          <Toaster />
          <NetworkStatus />
          <InstallPrompt />
        </SocketProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App; 